export const IchAppRoutes = {
    ROOT: "/ichapp/settings",
    REGISTRATION: "/ichapp/settings/registration",
    EMAIL_VERIFICATION: "/ichapp/settings/verification",
    CONTRACT: "/ichapp/settings/contract",
    SIGNING: "/ichapp/settings/signing",
    SUCCESS: "/ichapp/settings/success",

    DEREGISTRATION: "/ichapp/settings/deregistration",
    DEREGISTRATION_SIGNING: "/ichapp/settings/deregistration/signing",
    DEREGISTRATION_SUCCESS: "/ichapp/settings/deregistration/success",

    PDF: "/ichapp/settings/pdf",
};



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppRoutes.ts